import type { AxiosInstance } from 'axios';
import type {
  ChartElement,
  ChartElementListResponse,
  ListQueryParams,
  EntityId,
} from '@/types';

export const getChartElements = async (
  api: AxiosInstance,
  chart_id: EntityId,
  section_id: EntityId,
  limit = 50,
  start_key: string | undefined = undefined,
  name: string | undefined = undefined,
): Promise<ChartElementListResponse> => {
  const resp = await api.get<ChartElementListResponse>(
    `/chart/${chart_id}/section/${section_id}/element`,
    {
      params: { limit, start_key, name } as ListQueryParams,
    },
  );
  return resp.data;
};

export const getChartElement = async (
  api: AxiosInstance,
  chart_id: EntityId,
  section_id: EntityId,
  element_id: EntityId,
): Promise<ChartElement> => {
  const resp = await api.get<ChartElement>(
    `/chart/${chart_id}/section/${section_id}/element/${element_id}`,
  );
  return resp.data;
};

export const createChartElement = async (
  api: AxiosInstance,
  chart_id: EntityId,
  section_id: EntityId,
  values: Omit<ChartElement, 'entity_id' | 'created_at' | 'updated_at'>,
): Promise<ChartElement> => {
  const resp = await api.post<ChartElement>(
    `/chart/${chart_id}/section/${section_id}/element`,
    values,
  );
  return resp.data;
};

export const updateChartElement = async (
  api: AxiosInstance,
  chart_id: EntityId,
  section_id: EntityId,
  element_id: EntityId,
  values: Partial<Omit<ChartElement, 'entity_id' | 'created_at' | 'updated_at'>>,
): Promise<ChartElement> => {
  const resp = await api.put<ChartElement>(
    `/chart/${chart_id}/section/${section_id}/element/${element_id}`,
    values,
  );
  return resp.data;
};

export const deleteChartElement = async (
  api: AxiosInstance,
  chart_id: EntityId,
  section_id: EntityId,
  element_id: EntityId,
): Promise<void> => {
  const resp = await api.delete(
    `/chart/${chart_id}/section/${section_id}/element/${element_id}`,
  );
  return resp.data;
};

